import { TFunction } from 'react-i18next'
const prefix = 'configuration.userProfile.tabs'

export const translations = (t: TFunction) => ({
  configuration: {
    userProfile: {
      tabs: {
        courses: {
          rowsCount: t(`${prefix}.courses.rowsCount`),
          rowsCountPlural: t(`${prefix}.courses.rowsCountPlural`),
          header: {
            title: t(`${prefix}.courses.header.title`),
            description: t(`${prefix}.courses.header.description`),
          },
          name: t(`${prefix}.courses.name`),
          profiles: t(`${prefix}.courses.profiles`),
          mandatory: {
            title: t(`${prefix}.courses.mandatory.title`),
            required: t(`${prefix}.courses.mandatory.required`),
            optional: t(`${prefix}.courses.mandatory.optional`),
          },
          type: t(`${prefix}.courses.type`),
          advance: t(`${prefix}.courses.advance`),
          approvalStatus: t(`${prefix}.courses.approvalStatus`),
          period: t(`${prefix}.courses.period`),
          emptyState: {
            noMatches: t(`${prefix}.courses.emptyState.noMatches`),
            noCourses: t(`${prefix}.courses.emptyState.noCourses`),
          },
        },
        certificates: {
          rowsCount: t(`${prefix}.certificates.rowsCount`),
          rowsCountPlural: t(`${prefix}.certificates.rowsCountPlural`),
          header: {
            title: t(`${prefix}.certificates.header.title`),
            description: t(`${prefix}.certificates.header.description`),
          },
          name: t(`${prefix}.certificates.name`),
          mandatory: {
            title: t(`${prefix}.certificates.mandatory.title`),
            required: t(`${prefix}.certificates.mandatory.required`),
            optional: t(`${prefix}.certificates.mandatory.optional`),
          },
          type: t(`${prefix}.certificates.type`),
          download: t(`${prefix}.certificates.download`),
          downloadSelectedCertificates: t(
            `${prefix}.certificates.downloadSelectedCertificates`
          ),
          notifications: {
            download: t(`${prefix}.certificates.notifications.download`),
            downloadSelected: t(
              `${prefix}.certificates.notifications.downloadSelected`
            ),
          },
          emptyState: {
            noMatches: t(`${prefix}.certificates.emptyState.noMatches`),
            noCertificates: t(
              `${prefix}.certificates.emptyState.noCertificates`
            ),
          },
        },
      },
    },
  },
})
